<template>
  <div class="project300-view project300-layout">
    <header class="project300-header">
      <div class="project300-header__left">
        <div class="project300-header__logo">
          <img
            :src="require('@/assets/project300/logo.png')"
            alt="Project 300 Logo"
            :width="314"
            :height="55"
          />
        </div>
        <p class="mem-font--project300__body mem-font--project300__body--expanded project300-header__text">
          This is your home base as a participant in the study of a lifetime.  Let's get you onboarded into our system.
        </p>
      </div>
      <!--
      <div class="project300-header__right">
        <span class="mem-font--project300__body--small project300-header__span">
          Can't find what you're looking for?
        </span>
        <button class="mem-font--project300__button">
          CONTACT US
        </button>
      </div>
      -->
    </header>

    <v-expansion-panels v-model="panel" accordion class="project300-accordion">
      <v-expansion-panel>
        <v-expansion-panel-header class="mem-font--project300__title">
          Onboarding checklist
          <span v-if="showCompleted" class="completed-label">(completed)</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <OnboardItem
            v-for="item in userJourney?.items"
            :key="item.id"
            :id="item.id"
            :checked="item.checked"
            :title="item.title"
            :url="item.redirect_url"
            :linkText="item.redirect_url_text"
            :listItems="item.description"
            @handleCheck="toggleCheck"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <section class="project300-cta-section" v-if="metricItems && metricItems.length">
      <h3 class="mem-font--project300__title mem-font--project300__title">
        Metric Tracking
      </h3>
      <p class="mem-font--project300__body mem-font--project300__body--muted">
        Track your progress each month to stay accountable and see your momentum build over time.
      </p>
      <div class="metric-cards-container">
        <MetricsCard
          v-for="item in metricItems"
          :key="item.id"
          :item="item" 
          @enter-result="resultEntry(item.id)"
          @view-stats="viewStats(item.id)"/>
      </div>
    </section>
    <section class="project300-cta-section" v-else>
      <h3 class="mem-font--project300__title mem-font--project300__title--muted">
        Metric Tracking
      </h3>
      <h2 class="mem-font--project300__hero">COMING SOON</h2>
    </section>
    <section class="project300-partner-hub-section">
      <h3 class="mem-font--project300__title">
        Partner Hub
      </h3>
      <PartnerItem
        v-for="item in partnerItems"
        :key="item.id"
        :name="item.name"
        :description="item.description"
        :image="item.image"
        :url="item.url"
      />
    </section>
    <section class="project300-faq-section">
      <h3 class="mem-font--project300__title">
        FAQ
      </h3>
      <v-expansion-panels v-model="faqPanel" accordion class="project300-accordion">
        <v-expansion-panel v-for="(item, index) in faqItems" :key="item.id" class="project300-faq-panel">
          <v-expansion-panel-header class="mem-font--project300__faq-question-title mem-font--project300__title--muted">
            {{ item.question }}
            <template v-slot:actions>
              <svg v-if="faqPanel === index" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 8H18V10H0V8Z" fill="white"/>
              </svg>
              <svg v-else width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0V8H0V10H8V18H10V10H18V8H10V0H8Z" fill="white"/>
              </svg>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p class="mem-font-project300__faq-answer">{{ item.answer }}</p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </section>
    <v-dialog
      v-model="showResultEntryPopup"
      overlay-color="#2a2a2a"
      overlay-opacity="0.9"
      :max-width="selectedExcerciseObject?.unit_type === 'grade' ? '568px' : '440px'"
      @click:outside="[showResultEntryPopup = false, selectedExcercise = null]">
      <EntryPopup
        v-if="selectedExcerciseObject"
        :title="selectedExcerciseObject.title"
        :id="selectedExcerciseObject.id"
        :unit="selectedExcerciseObject.unit_type"
        @close-entry="[showResultEntryPopup = false, selectedExcercise = null]" />
    </v-dialog>
    <v-dialog
      v-model="showStatsPopup"
      overlay-color="#2a2a2a"
      overlay-opacity="0.9"
      max-width="1080px"
      @click:outside="[showStatsPopup = false, selectedExcercise = null]">
      <ProgressPopup
        v-if="selectedExcerciseObject && selectedExcerciseObject.progress && selectedExcerciseObject.progress.length"
        :progress="selectedExcerciseObject.progress"
        :unit="selectedExcerciseObject.unit_type"
         @close-progress="[showStatsPopup = false, selectedExcercise = null]" />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OnboardItem from '@/components/Project300/OnboardItem.vue'
import PartnerItem from '@/components/Project300/PartnerItem.vue'
import MetricsCard from '@/components/Project300/MetricsCard'

import { some } from 'lodash'

export default {
  name: 'Project300View',
  components: {
    OnboardItem,
    PartnerItem,
    MetricsCard,
    EntryPopup: () => import('@/components/Project300/EntryPopup'),
    ProgressPopup: () => import('@/components/Project300/ProgressPopup')
  },
  data() {
    return {
      panel: null,
      faqPanel: null,
      showCompleted: false,
      showResultEntryPopup: false,
      showStatsPopup: false,
      selectedExcercise: null,
    }
  },
  computed: {
    ...mapGetters(['partnerItems', 'faqItems', 'userJourney', 'metricItems']),
    selectedExcerciseObject() {
      return this.selectedExcercise ? this.metricItems.find(el => el.id === this.selectedExcercise) : null
    }
  },
  methods: {
    ...mapActions(['updateUserJourney', 'handleToolbarNotification']),
    resultEntry(evt) {
      this.showResultEntryPopup = true
      this.showStatsPopup = false
      this.selectedExcercise = evt
    },
    viewStats(evt) {
      this.showStatsPopup = true
      this.showResultEntryPopup = false
      this.selectedExcercise = evt
    },
    async toggleCheck(evt) {
      try {
        await this.updateUserJourney(evt.id)
      } catch(e) {
        this.handleToolbarNotification({
          type: "warning",
          text: e.text,
          isVisible: true,
          canClose: true, 
          closeTimeout: 3000,
        });
      }
    }
  },
  beforeMount() {
    const anyUnchecked = some(this.userJourney?.items, { checked: false})
    let journey = JSON.parse(sessionStorage.getItem('journey'))
    const savedUnchecked = some(journey?.items, { checked: false })
    if (anyUnchecked || savedUnchecked) {
      this.panel = 0
      this.showCompleted = false
    } else {
      this.showCompleted = true
      this.panel = null
    }
  },
  watch: {
    'userJourney': {
      handler() {
        const anyUnchecked = some(this.userJourney?.items, { checked: false})
        if (anyUnchecked) {
          this.panel = 0
          this.showCompleted = false
        } else {
          this.showCompleted = true
          this.panel = null
        }
      },
      deep: true
    },
    $route() {
      let journey = JSON.parse(sessionStorage.getItem('journey'))
      if(!journey) {
        this.$router.push('/')
      }
    } 
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      let journey = JSON.parse(sessionStorage.getItem('journey'))
      if(!journey) {
        next('/')
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/project300.scss";

.completed-label {
  margin-left: 8px;
}

.metric-cards-container {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
  @media screen and (min-width: 868px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (min-width: 1120px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
